"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlayerStartStage = void 0;
/**
 * Стадии запуска плеера.
 */
var PlayerStartStage;
(function (PlayerStartStage) {
    /**
     * Плеер готовится к запуску.
     */
    PlayerStartStage["init"] = "init";
    /**
     * Плеер ждет пользовательского действия для запуска (может быть пропущено).
     * Может выставляться в том числе из-за того, что детект автоплея выполнялся слишком долго.
     */
    PlayerStartStage["waitForUserPlay"] = "waitForUserPlay";
    /**
     * Плеер был запущен в скрытом документе, ждем, пока документ станет видимым.
     */
    PlayerStartStage["waitForDocumentVisibility"] = "waitForDocumentVisibility";
    /**
     * Плеер запускается.
     */
    PlayerStartStage["starting"] = "starting";
    /**
     * Плеер запущен.
     */
    PlayerStartStage["started"] = "started";
    /**
     * Плеер сломан при запуске.
     */
    PlayerStartStage["broken"] = "broken";
    /**
     * Плеер завершил свою работу.
     */
    PlayerStartStage["destroyed"] = "destroyed";
})(PlayerStartStage || (exports.PlayerStartStage = PlayerStartStage = {}));
